import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import CommercialMessage from "@ingka/commercial-message";
import Price from "@ingka/price";
import PriceAddons from "./elements/PriceAddons.mjs";
import ProductName from "./elements/ProductName.mjs";
import EnergyClass from "./elements/EnergyClass.mjs";
import OfferMessage from "./elements/OfferMessage.mjs";
import ProductDescription from "./elements/ProductDescription.mjs";
import ComparisonPrice from "./elements/ComparisonPrice.mjs";
import {
  hasCommercialMessage,
  hasComparisonPrice,
  getCommercialMessageVariant,
  hasBTI
} from "@ingka/price-module-shared";
var EmphasisedOfferTypes = /* @__PURE__ */ ((EmphasisedOfferTypes2) => {
  EmphasisedOfferTypes2[EmphasisedOfferTypes2["none"] = 0] = "none";
  EmphasisedOfferTypes2[EmphasisedOfferTypes2["bti"] = 1] = "bti";
  EmphasisedOfferTypes2[EmphasisedOfferTypes2["tro"] = 2] = "tro";
  EmphasisedOfferTypes2[EmphasisedOfferTypes2["nlp"] = 3] = "nlp";
  return EmphasisedOfferTypes2;
})(EmphasisedOfferTypes || {});
const PriceModule = (props) => {
  const {
    prefix = "",
    productName,
    productDescription,
    commercialMessageProps,
    priceOfferType = "none",
    comparisonPriceProps,
    currentPriceProps,
    secondaryCurrencyPriceProps,
    secondaryCurrencyComparisonPriceProps,
    priceAddons,
    energyClass,
    productNameHeadingTag = "div",
    size = "medium",
    completePriceLabel,
    className,
    commercialMessagePlaceholder,
    comparisonPriceLabel,
    offerMessageProps,
    ...other
  } = props;
  const baseClass = `${prefix}price-module`;
  const withCommercialMessage = hasCommercialMessage(
    priceOfferType,
    commercialMessageProps
  );
  const classes = cx(
    baseClass,
    `${baseClass}--${size}`,
    withCommercialMessage && `${baseClass}--with-commercial-message`,
    !withCommercialMessage && commercialMessagePlaceholder && `${baseClass}--commercial-message-placeholder`,
    priceOfferType && `${baseClass}--${priceOfferType}`,
    className
  );
  const comparisonPrice = hasComparisonPrice(
    Boolean(comparisonPriceProps),
    priceOfferType
  ) ? /* @__PURE__ */ jsx(
    ComparisonPrice,
    {
      prefix,
      ...comparisonPriceProps,
      fixedSize: true
    }
  ) : null;
  const secondaryCurrencyComparisonPrice = hasComparisonPrice(
    Boolean(secondaryCurrencyComparisonPriceProps),
    priceOfferType
  ) ? /* @__PURE__ */ jsx(
    ComparisonPrice,
    {
      prefix,
      ...secondaryCurrencyComparisonPriceProps,
      fixedSize: true
    }
  ) : null;
  const offerMessageType = priceOfferType === "family" || priceOfferType === "family-romania" ? "family" : offerMessageProps?.emphasised && priceOfferType in EmphasisedOfferTypes ? "emphasised" : "subtle";
  return /* @__PURE__ */ jsxs("div", { className: classes, ...other, children: [
    /* @__PURE__ */ jsxs("div", { className: `${baseClass}__information`, children: [
      withCommercialMessage && /* @__PURE__ */ jsx(
        CommercialMessage,
        {
          prefix,
          subtle: true,
          ...commercialMessageProps,
          variant: getCommercialMessageVariant(priceOfferType)
        }
      ),
      /* @__PURE__ */ jsx(
        ProductName,
        {
          productNameHeadingTag,
          prefix,
          name: productName,
          children: /* @__PURE__ */ jsx(
            ProductDescription,
            {
              prefix,
              description: productDescription
            }
          )
        }
      )
    ] }),
    completePriceLabel && /* @__PURE__ */ jsxs("span", { className: `${baseClass}__complete-price`, children: [
      " ",
      completePriceLabel,
      " "
    ] }),
    /* @__PURE__ */ jsxs("div", { className: `${baseClass}__price`, children: [
      priceOfferType === "family-romania" && /* @__PURE__ */ jsx(
        CommercialMessage,
        {
          prefix,
          subtle: true,
          ...commercialMessageProps,
          variant: "family"
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: `${baseClass}__primary-currency-price`, children: [
        comparisonPrice,
        /* @__PURE__ */ jsx(
          Price,
          {
            bti: hasBTI(priceOfferType),
            ...currentPriceProps,
            prefix,
            className: cx(
              `${baseClass}__current-price`,
              currentPriceProps.className
            )
          }
        ),
        priceOfferType !== "family-romania" && /* @__PURE__ */ jsx(EnergyClass, { prefix, children: energyClass })
      ] }),
      secondaryCurrencyPriceProps && priceOfferType !== "family-romania" && /* @__PURE__ */ jsxs("div", { className: `${baseClass}__secondary-currency-price`, children: [
        secondaryCurrencyComparisonPrice,
        /* @__PURE__ */ jsx(
          Price,
          {
            bti: hasBTI(priceOfferType),
            ...secondaryCurrencyPriceProps,
            prefix,
            className: cx(
              `${baseClass}__secondary-current-price`,
              currentPriceProps.className
            )
          }
        )
      ] }),
      priceOfferType === "family-romania" && comparisonPriceLabel && /* @__PURE__ */ jsx("span", { className: `${baseClass}__comparison-price-label`, children: comparisonPriceLabel }),
      priceOfferType === "family-romania" && comparisonPriceProps && /* @__PURE__ */ jsxs("div", { className: `${baseClass}__primary-currency-price`, children: [
        /* @__PURE__ */ jsx(
          Price,
          {
            ...comparisonPriceProps,
            prefix,
            className: cx(
              `${baseClass}__current-price ${baseClass}__regular-price`,
              comparisonPriceProps.className
            )
          }
        ),
        /* @__PURE__ */ jsx(EnergyClass, { prefix, children: energyClass })
      ] })
    ] }),
    offerMessageProps && /* @__PURE__ */ jsx(
      OfferMessage,
      {
        prefix,
        type: offerMessageType,
        bullet: offerMessageProps.bullet,
        children: offerMessageProps.children
      }
    ),
    priceAddons && /* @__PURE__ */ jsx(PriceAddons, { prefix, children: priceAddons })
  ] });
};
var PriceModule_default = PriceModule;
export {
  PriceModule_default as default
};
